// extracted by mini-css-extract-plugin
export default {"car_active":"vehicle-cell_car_active__FZZap","car_inactive":"vehicle-cell_car_inactive__tVo+n"};